<template>
    <div class="flex_1">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<div v-if="activeTab === tabTypes.profile" class="flex flex_1 flex_column flex_start">
			<ProfileInfo @loaded="profileLoaded"></ProfileInfo>
			<ChangePassword class="margin_top" :email="profileData.email"></ChangePassword>
		</div>
		<ApiKeys v-if="activeTab === tabTypes.apiKeys"/>
    </div>
</template>

<script>
import ChangePassword from "./ChangePassword";
import ProfileInfo from "@/views/user/profile/ProfileInfo";
import ApiKeys from "@/views/user/profile/apiKeys/ApiKeys";
import {enumDef} from "@/common/enumDefs";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
    components: {
        ApiKeys,
        ProfileInfo,
        ChangePassword,
		AccessRestrictedTabs
    },
    data() {
        let tabTypes = {
            profile: {
            	name: navigationTabs.admin.profile.info,
				translationKey: "user.profile.tab.profile",
				permission: enumDef.permissions.AdminProfile
			},
			apiKeys: {
				name: navigationTabs.admin.profile.apiKeys,
				translationKey: "user.profile.tab.apiKeys",
				permission: enumDef.permissions.AdminProfile
			},
        };
        return {
            tabTypes: tabTypes,
            activeTab: null,
            profileData: {
                email: ""
            }
        };
    },
    methods: {
        profileLoaded(data) {
            this.profileData = data;
        }
    },
};
</script>